<ng-template #content>
  <ng-content />
</ng-template>

@if (state.isMobile) {
  @if (mobileTopPanel(); as panel) {
    <div #mobileTopPanelContainer>
      <ng-container *ngTemplateOutlet="panel" />
    </div>
  }
  <div class="mobile-view" [class.hidden]="state.isHidden">
    <ng-container *ngTemplateOutlet="sidenavContent; context: { $implicit: true }" />
  </div>
  <div
    class="shell-container-mobile"
    [class.has-top-panel]="hasMobileTopPanel()"
    [class.has-info-banner]="hasInfoBanner()"
    [style.--mobile-top-panel-height.px]="state.mobileTopPanelHeight"
  >
    <ng-container *ngTemplateOutlet="content" />
  </div>
} @else {
  <mat-sidenav-container class="shell-container" [class.has-info-banner]="hasInfoBanner()">
    <mat-sidenav
      [disableClose]="true"
      mode="side"
      [opened]="true"
      [class.sidenav-hidden]="state.isHidden"
      [style.width.px]="state.isHidden ? 0 : state.isCompact ? COMPACT_WIDTH : NORMAL_WIDTH"
    >
      <ng-container *ngTemplateOutlet="sidenavContent; context: { $implicit: false }" />
    </mat-sidenav>
    <mat-sidenav-content
      class="sidenav-content bg-neutral-0 h-full"
      [style.margin-left.px]="state.isHidden ? 0 : state.isCompact ? COMPACT_WIDTH : NORMAL_WIDTH"
    >
      <ng-container *ngTemplateOutlet="content" />
    </mat-sidenav-content>
  </mat-sidenav-container>
}

<ng-template #sidenavContent let-isMobile>
  <div class="sidenav-wrap" [class.is-compact]="state.isCompact" [class.is-mobile]="isMobile">
    <div class="sidenav-inner flex h-full flex-col">
      <a [routerLink]="'/'" class="logo-link">
        @if (customLogo(); as logo) {
          <ng-container *ngTemplateOutlet="logo; context: { isCompact: state.isCompact, darkMode: state.darkMode }" />
        } @else {
          <dojo-app-logo
            [iconSrc]="logoCompact()"
            [iconSrcDark]="logoCompactDark()"
            [logoSrc]="logoFull()"
            [logoSrcDark]="logoFullDark()"
            [alt]="logoAlt()"
            [iconClass]="'w-[44px]'"
            [logoSecondClass]="'w-[111px]'"
            [compact]="state.isCompact"
          />
        }
      </a>

      <div class="sidenav-inner-links" [class.new-mobile-menu]="isMobile" [class.more-menu-open]="isMoreMenuOpen()">
        @for (item of items(); track item.route) {
          <a
            class="sidebar-link additional-margin"
            [routerLink]="item.route"
            routerLinkActive="active"
            (click)="isMobile && isMoreMenuOpen() && onMenuItemClick()"
          >
            <div class="sidebar-link-image">
              <dojo-icon
                [size]="30"
                [icon]="item.icon"
                [alt]="item.labelKey | transloco"
                [iconClass]="'feature-nav-icon feature-nav-icon--' + item.route"
              />
            </div>
            <span class="sidebar-link-text">{{
              (isMobile && item.labelKeyMobile ? item.labelKeyMobile : item.labelKey) | transloco
            }}</span>
          </a>
        }
        @if (isMobile && showMobileMoreButton()) {
          <button class="sidebar-link sidebar-link-more" [class.active]="isMoreMenuOpen()" (click)="onMoreClick()">
            <div class="sidebar-link-image">
              <dojo-icon
                [icon]="'ellipsis'"
                [ngClass]="isMoreMenuOpen() ? 'text-indigo-500' : 'text-neutral-200'"
                [size]="30"
              />
            </div>
            <span class="sidebar-link-text" [ngClass]="isMoreMenuOpen() ? '!text-primary' : 'text-secontary'">
              {{ 'examdojo.more' | transloco }}
            </span>
          </button>
        }
        @if (state.user && !(isMobile && showMobileMoreButton())) {
          <div class="flex grow flex-col justify-center gap-8 md:mt-auto md:grow-0 md:justify-start">
            @if (customFooter(); as footer) {
              <ng-container *ngTemplateOutlet="footer" />
            }
            <dojo-sidebar-profile-link
              [user]="state.user"
              [settingsRoute]="settingsRoute()"
              (clicked)="navigateToProfile()"
            />
          </div>
        }
      </div>
    </div>
  </div>
</ng-template>
